import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../../consts/api";

export const useSurchargeAgreement = (clinicId, options = {}) => {
  const res = useQuery(
    ["surchargeAgreement", clinicId],
    () => http.get(HTTP_ENDPOINTS.customTax.getSurchargeAgreement(clinicId)),
    {
      cacheTime: 0,
      enabled: Boolean(clinicId),
      select: (data) => data.data.data,
      ...options,
    },
  );

  return res;
};
